<template>
  <div>
    <RecycleScroller
      ref="recycleScroller"
      :items="allGroups"
      :item-height="140"
      :buffer="600"
      class="scroller"
      page-mode
      emit-update
      @update="onRecycleScrollerUpdated"
    >
      <VCard
        slot-scope="{ item, index }"
        color="blue-grey darken-2"
        ripple
        @click.stop="onCardClicked(item.listContactsRoute)"
      >
        <VContainer
          fluid
          grid-list-lg
        >
          <VLayout
            fill-height
            align-center
            justify-center
            row
            wrap
          >
            <VFlex xs12>
              <VCard
                color="blue-grey darken-2"
                class="white--text"
              >
                <VLayout
                  row
                  wrap
                  justify-space-between
                >
                  <VFlex
                    xs10
                  >
                    <VCardTitle primary-title>
                      <VLayout
                        row
                        wrap
                      >
                        <VFlex xs12>
                          <div class="headline">
                            {{ item.name }}
                          </div>
                        </VFlex>
                        <VFlex xs12>
                          <div>Profiles: ({{ item.profiles.length }})</div>
                        </VFlex>
                      </VLayout>
                    </VCardTitle>
                  </VFlex>
                  <VFlex
                    xs2
                  >
                    <VLayout
                      column
                      align-end
                      justify-space-between
                      fill-height
                    >
                      <VBtn
                        v-if="followup"
                        small
                        icon
                        dark
                        @click.stop="onFollowupClicked(index)"
                      >
                        <VIcon>mdi-calendar-star</VIcon>
                      </VBtn>
                    </VLayout>
                  </VFlex>
                </VLayout>
              </VCard>
            </VFlex>
          </VLayout>
        </VContainer>
      </VCard>
    </RecycleScroller>
    <GroupFollowupRuleDialog
      v-if="dialog"
      :name="dialogName"
      :group-id="dialogGroupId"
      :dialog.sync="dialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GroupFollowupRuleDialog from '@/components/automation/GroupFollowupRuleDialog'
export default {
  name: 'GroupTable',
  components: { GroupFollowupRuleDialog },
  props: {
    followup: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      dialog: false,
      dialogName: '',
      dialogGroupId: 0
    }
  },
  computed: {
    ...mapGetters({
      allGroups: 'group/getAllGroups',
      groupTotalCount: 'group/getTotalCount'
    })
  },
  methods: {
    tempRemove (event) {
      this.items.splice(event.index, 1)
    },
    onRecycleScrollerUpdated (startIndex, endIndex) {
      if (this.allGroups.length !== 0 && endIndex === this.allGroups.length && endIndex !== this.groupTotalCount) {
        this.$emit('fetchingMore')
      }
    },
    onCardClicked (route) {
      this.$router.push(route)
    },
    onFollowupClicked (index) {
      if (index < 0 || index >= this.allGroups.length) {
        return
      }
      const group = this.allGroups[index]
      if (group) {
        this.dialogName = `${group.name}`
        this.dialogGroupId = Number(group.id)
        this.dialog = true
      }
    }
  }
}
</script>

<style scoped>
  .scroller {
    height: 100%;
  }

  .user {
    height: 32%;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }
  .fluid {
    padding: 10px;
  }
</style>
